import * as R from 'ramda/src/index';
import moment from 'moment';
import qs from 'qs';
import {createHash} from 'providers/ferries/api';
import {validateQuery} from 'providers/ferries/validator';
import {getPortCode} from 'ferries/helpers/common';
import {languageFromUrl} from 'helpers/commonHelper';
import {language, bookingBaseUrl} from 'helpers/stableValues';

const {clicktag, ref, aff, utm_source, utm_campaign} = qs.parse(location.search.slice(1), {decoder: (c) => c});
const linkwiseUrl = `${clicktag}&lnkurl=`;

const createUrlParams = (ref, aff, utm_source, utm_campaign) => {
  const params = R.reject(R.isNil, [
    ref ? `ref=${ref}`: undefined,
    (aff === 'bookferry' && language === 'en') ? `partnerCode=${language}${aff}` : undefined,
    utm_source ? `utm_source=${utm_source}`: undefined,
    utm_campaign ? `utm_campaign=${utm_campaign}`: undefined
  ]).join('&');

  return params ? `?${params}`: params;
};

const buildFerryUrl = (query) => (
  validateQuery(query)
    .then(({trips}) => {
      const queryFerryResults = {
        dep: trips.map(({dep}) => getPortCode(dep)),
        arr: trips.map(({arr}) => getPortCode(arr)),
        date: trips.map(({obDate}) => moment(obDate))
      };

      const url = `${location.origin}${languageFromUrl()}/${bookingBaseUrl}/results` +
        `${createUrlParams(ref, aff, utm_source, utm_campaign)}${createHash(queryFerryResults)}`;
      if (clicktag) {
        return `${linkwiseUrl}${encodeURIComponent(url)}`;
      }
      return url;
    })
);

const buildAddTripUrl = ({dep, arr, obDate}) => {
  const date = moment(obDate);
  const params = R.reject(R.isNil, [
    R.isEmpty(dep) ? undefined : `dep=${getPortCode(dep)}`,
    R.isEmpty(arr) ? undefined : `arr=${getPortCode(arr)}`,
    `date=${date.format('YYYY-MM-DD')}`,
    'tripType=multiTrip',
    ref ? `ref=${ref}`: undefined,
    (aff === 'bookferry' && language === 'en') ? `partnerCode=${language}${aff}` : undefined,
    utm_source ? `utm_source=${utm_source}`: undefined,
    utm_campaign ? `utm_campaign=${utm_campaign}`: undefined
  ]).join('&');

  const url = `${location.origin}${languageFromUrl()}/${bookingBaseUrl}?${params}`;

  if (clicktag) {
    return `${linkwiseUrl}${encodeURIComponent(url)}`;
  }
  return url;
};

const getPopularPorts = (ports) => R.take(15, ports);

export {buildFerryUrl, buildAddTripUrl, getPopularPorts};
